import {
  GET_CN_LOCATION_LIST,
  SET_CN_LOCATION_LIST,
  UPDATE_REQUIRED_DOCS_CHECK_LIST,
  SHOW_GLOBAL_LOADER,
  HIDE_GLOBAL_LOADER,
  ADD_CAR_ELIGIBILITY_REQUEST,
  ADD_CAR_ELIGIBILITY_SUCCESS,
  ADD_CAR_ELIGIBILITY_FAILURE,
  CLEAR_ADD_CAR_ELIGIBILITY_STATUS,
  CLEAR_REFRESH_CAPTCHA_STATUS,
  ADD_CAR_VIN_CHANGE,
  ADD_CAR_ADDRESS_INPUT_CHANGE,
  ADD_CAR_UPLOAD_DOCUMENTS_REQUEST,
  ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS,
  ADD_CAR_UPLOAD_DOCUMENTS_FAILURE,
  ADD_CAR_UPLOAD_DOCUMENTS_REMOVE,
  ADD_CAR_PROCESS_REQUEST,
  ADD_CAR_PROCESS_SUCCESS,
  ADD_CAR_PROCESS_FAILURE,
  CLEAR_ADD_CAR_PROCESS_STATUS,
  GET_SIGNED_TOKEN_REQUEST,
  GET_SIGNED_TOKEN_SUCCESS,
  GET_SIGNED_TOKEN_FAILURE,
  GET_TRANSLATIONS,
  GET_USER_SIGNED_TOKEN_REQUEST,
  GET_USER_SIGNED_TOKEN_SUCCESS,
  GET_USER_SIGNED_TOKEN_FAILURE,
  CLEAR_ERROR,
  RESET_SIGNED_TOKEN,
  REMOVE_CAR_NEW_OWNER_INFORMATION_CHANGE,
  REMOVE_CAR_REQUEST,
  REMOVE_CAR_SUCCESS,
  REMOVE_CAR_FAILURE,
  CLEAR_REMOVE_CAR_REQUEST_STATUS,
  CONFIRM_TRANSFER_REQUEST,
  CONFIRM_TRANSFER_SUCCESS,
  CONFIRM_TRANSFER_FAILURE,
  CLEAR_CONFIRM_TRANSFER_REQUEST_STATUS,
  FETCH_BILLING_ADDRESS_INITIAL_REQUEST,
  FETCH_BILLING_ADDRESS_REQUEST,
  FETCH_BILLING_ADDRESS_SUCCESS,
  FETCH_BILLING_ADDRESS_FAILURE,
  UPDATE_BILLING_ADDRESS_REQUEST,
  UPDATE_BILLING_ADDRESS_SUCCESS,
  UPDATE_BILLING_ADDRESS_FAILURE,
  BILLING_ADDRESS_MODAL_TOGGLE,
} from './types';

const action = type => payload => ({
  type,
  payload,
});

export const getTranslations = action(GET_TRANSLATIONS);

export const showGlobalLoader = action(SHOW_GLOBAL_LOADER);
export const hideGlobalLoader = action(HIDE_GLOBAL_LOADER);

// add car

export const getCNLocationList = action(GET_CN_LOCATION_LIST);
export const setCNLocationList = action(SET_CN_LOCATION_LIST);
export const updateRequiredDocsCheckList = action(UPDATE_REQUIRED_DOCS_CHECK_LIST);

export const addCarEligibilityRequest = action(ADD_CAR_ELIGIBILITY_REQUEST);
export const addCarEligibilitySuccess = action(ADD_CAR_ELIGIBILITY_SUCCESS);
export const addCarEligibilityFailure = action(ADD_CAR_ELIGIBILITY_FAILURE);
export const clearAddCarEligibilityStatus = action(CLEAR_ADD_CAR_ELIGIBILITY_STATUS);
export const clearRefreshCaptchaStatus = action(CLEAR_REFRESH_CAPTCHA_STATUS);

export const addCarVinChange = action(ADD_CAR_VIN_CHANGE);

export const addCarAddressInputChange = action(ADD_CAR_ADDRESS_INPUT_CHANGE);

export const addCarUploadDocumentsRequest = action(ADD_CAR_UPLOAD_DOCUMENTS_REQUEST);
export const addCarUploadDocumentsSuccess = action(ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS);
export const addCarUploadDocumentsFailure = action(ADD_CAR_UPLOAD_DOCUMENTS_FAILURE);
export const addCarUploadDocumentsRemove = action(ADD_CAR_UPLOAD_DOCUMENTS_REMOVE);

export const addCarProcessRequest = action(ADD_CAR_PROCESS_REQUEST);
export const addCarProcessSuccess = action(ADD_CAR_PROCESS_SUCCESS);
export const addCarProcessFailure = action(ADD_CAR_PROCESS_FAILURE);
export const clearAddCarProcessStatus = action(CLEAR_ADD_CAR_PROCESS_STATUS);

export const getSignedTokenRequest = action(GET_SIGNED_TOKEN_REQUEST);
export const getSignedTokenSuccess = action(GET_SIGNED_TOKEN_SUCCESS);
export const getSignedTokenFailure = action(GET_SIGNED_TOKEN_FAILURE);

export const getUserSignedTokenRequest = action(GET_USER_SIGNED_TOKEN_REQUEST);
export const getUserSignedTokenSuccess = action(GET_USER_SIGNED_TOKEN_SUCCESS);
export const getUserSignedTokenFailure = action(GET_USER_SIGNED_TOKEN_FAILURE);

export const clearError = action(CLEAR_ERROR);
export const resetSignedToken = action(RESET_SIGNED_TOKEN);

export const fetchBillingAddressInitialRequest = action(FETCH_BILLING_ADDRESS_INITIAL_REQUEST);
export const fetchBillingAddressRequest = action(FETCH_BILLING_ADDRESS_REQUEST);
export const fetchBillingAddressSuccess = action(FETCH_BILLING_ADDRESS_SUCCESS);
export const fetchBillingAddressFailure = action(FETCH_BILLING_ADDRESS_FAILURE);

export const updateBillingAddressRequest = action(UPDATE_BILLING_ADDRESS_REQUEST);
export const updateBillingAddressSuccess = action(UPDATE_BILLING_ADDRESS_SUCCESS);
export const updateBillingAddressFailure = action(UPDATE_BILLING_ADDRESS_FAILURE);
export const billingAddressModalToggle = action(BILLING_ADDRESS_MODAL_TOGGLE);

// remove car
export const removeCarNewOwnerInformationChange = action(REMOVE_CAR_NEW_OWNER_INFORMATION_CHANGE);

export const removeCarRequest = action(REMOVE_CAR_REQUEST);
export const removeCarSuccess = action(REMOVE_CAR_SUCCESS);
export const removeCarFailure = action(REMOVE_CAR_FAILURE);

export const clearRemoveCarRequestStatus = action(CLEAR_REMOVE_CAR_REQUEST_STATUS);

export const confirmTransferRequest = action(CONFIRM_TRANSFER_REQUEST);
export const confirmTransferSuccess = action(CONFIRM_TRANSFER_SUCCESS);
export const confirmTransferFailure = action(CONFIRM_TRANSFER_FAILURE);

export const clearConfirmTransferRequestStatus = action(CLEAR_CONFIRM_TRANSFER_REQUEST_STATUS);
